import { ReactElement, useState } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import { Alert, Col, Row } from '@op/opds.opux';
import CourseTaskHeader from '../../CourseTaskHeader';
import { getMsgValues } from '../../../utils';
import SegmentedButtonQuestionTile from '../../SegmentedButtonQuestionTile';

const COURSE_NUMBER = 6;
const TASK_NUMBER = 2;

const TaskTwo = (): ReactElement => {
  const options1 = getMsgValues(useMessage('course6.task2.question1.options'));
  const options2 = getMsgValues(useMessage('course6.task2.question2.options'));
  const options3 = getMsgValues(useMessage('course6.task2.question3.options'));
  const options4 = getMsgValues(useMessage('course6.task2.question4.options'));

  const [correctAnswers, setCorrectAnswers] = useState(Array(4).fill(false));

  const updateAnswers = (value: 1 | 2 | 3 | 4) => {
    return (isCorrect: boolean): void => {
      const newAnswers = [...correctAnswers];
      newAnswers[value - 1] = isCorrect;
      setCorrectAnswers(newAnswers);
    };
  };

  return (
    <div style={{ marginTop: space.default }}>
      <CourseTaskHeader questionNumber={2} totalQuestions={2} />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl }}
      >
        <Message id="course6.task2.title" />
      </h3>
      <div
        className="opds-styles-v1-text-body-medium"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.default,
        }}
      >
        <Message id="course6.task2.body" />
      </div>
      <Row style={{ margin: 0 }}>
        <Col
          className="investoracademy-profit-column-left"
          style={{ display: 'flex', flexDirection: 'row' }}
          xs={12}
          md={6}
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="1"
            correctAnswer={options1[1]}
            options={options1}
            onAnswered={updateAnswers(1)}
          />
        </Col>
        <Col
          className="investoracademy-profit-column-right"
          style={{ display: 'flex', flexDirection: 'row' }}
          xs={12}
          md={6}
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="2"
            correctAnswer={options2[0]}
            options={options2}
            onAnswered={updateAnswers(2)}
          />
        </Col>
        <Col
          className="investoracademy-profit-column-left"
          style={{ display: 'flex', flexDirection: 'row' }}
          xs={12}
          md={6}
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="3"
            correctAnswer={options3[1]}
            options={options3}
            onAnswered={updateAnswers(3)}
          />
        </Col>
        <Col
          className="investoracademy-profit-column-right"
          style={{ display: 'flex', flexDirection: 'row' }}
          xs={12}
          md={6}
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="4"
            correctAnswer={options4[0]}
            options={options4}
            onAnswered={updateAnswers(4)}
          />
        </Col>
      </Row>
      {correctAnswers.filter(Boolean).length === 4 && (
        <Alert type="positive">
          <Message id="answers_correct" />
        </Alert>
      )}
    </div>
  );
};

export default TaskTwo;
